// extracted by mini-css-extract-plugin
export default {"formButton":"Button_formButton__uncEg"};